function SkeletonRow() {
  return (
    <div className="flex items-start gap-4 rounded-xl px-4 py-4">
      <div
        className="flex-shrink-0 rounded-full tasks-shimmer"
        style={{ width: 40, height: 40 }}
      />
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <div className="tasks-shimmer rounded" style={{ height: 14, width: '40%' }} />
        <div className="tasks-shimmer rounded" style={{ height: 11, width: '55%' }} />
        <div className="tasks-shimmer rounded" style={{ height: 11, width: '70%' }} />
      </div>
      <div className="flex-shrink-0 self-center">
        <div className="tasks-shimmer rounded" style={{ height: 28, width: 110 }} />
      </div>
    </div>
  );
}

export function TaskListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-1">
      {Array.from({ length: rows }, (_, idx) => (
        <SkeletonRow key={idx} />
      ))}
      <style>{`
        @keyframes tasks-shimmer {
          0% { background-position: -200px 0; }
          100% { background-position: calc(200px + 100%) 0; }
        }
        .tasks-shimmer {
          background: linear-gradient(
            90deg,
            var(--surface-tertiary) 0%,
            var(--surface-secondary) 50%,
            var(--surface-tertiary) 100%
          );
          background-size: 200px 100%;
          background-repeat: no-repeat;
          animation: tasks-shimmer 1400ms ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
